import httpClient from '@/http-client'
export const get = (Options = {}) => {
  return httpClient
    .get('/api/class-teaching', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getDetails = (Options = {}) => {
  return httpClient
    .get('/api/class-teaching-details', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const exportExcel = attributes => {
  return httpClient
    .post('/api/class-teaching/excel-exports', attributes, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}

export default { get, getDetails, exportExcel }
